import * as React from 'react';
import { RadioButton } from '@cian/ui-kit';
import { UiKitContextProvider } from '@cian/ui-kit/context';
import { useDispatch, useSelector } from 'react-redux';

import { getUserStatus } from '../../selectors/newAnswer';
import { setUserStatus } from '../../actions/newAnswer';
import { UserStatus } from '../../components/NewAnswer/parts/UserStatus';
import { EUserStatus } from '../../types/newAnswer/userStatus';

export const UserStatusContainer = () => {
  const value = useSelector(getUserStatus);
  const dispatch = useDispatch();

  const onChange = React.useCallback(
    /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
    (e: React.ChangeEvent<HTMLInputElement>, _value: any) => {
      dispatch(setUserStatus(e.currentTarget.value as EUserStatus));
    },
    [dispatch],
  );

  return (
    <UiKitContextProvider useStaticDeviceType={true} deviceType="desktop">
      <UserStatus
        title="Статус"
        statuses={[
          <RadioButton
            size="M"
            key={`userStatus_${EUserStatus.Seeker}`}
            defaultChecked={value === EUserStatus.Seeker}
            label="В поиске"
            name="userStatusAnswer"
            onChange={onChange}
            value={EUserStatus.Seeker}
          />,
          <RadioButton
            size="M"
            key={`userStatus_${EUserStatus.Execute}`}
            defaultChecked={value === EUserStatus.Execute}
            label="На стадии сделки"
            name="userStatusAnswer"
            onChange={onChange}
            value={EUserStatus.Execute}
          />,
          <RadioButton
            size="M"
            key={`userStatus_${EUserStatus.Owning}`}
            defaultChecked={value === EUserStatus.Owning}
            label="Квартира в этом ЖК"
            name="userStatusAnswer"
            onChange={onChange}
            value={EUserStatus.Owning}
          />,
        ]}
      />
    </UiKitContextProvider>
  );
};
